import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import { Button, Modal } from 'react-bootstrap'
import { SessionContainer } from './Components'

import styles from './responseContainer.module.scss'

const InlineModal = ({widgetProps, className, show, onSubmit, breakpoint, handleSuggestionClick, onClose}) => {
  return (
    <div className={cx(className)}>
      <SessionContainer
        show={show}
        handleSuggestionClick={handleSuggestionClick}
        breakpoint={breakpoint}
        onSubmit={onSubmit}
        widgetProps={widgetProps}
        onClose={onClose}
      />
    </div>
  )
}

const inlineConatinerEquals = function (prevProps, nextProps) {
  const paths = ['className', 'widgetProps', 'breakpoint', 'show', 'onChange', 'onSubmit', 'handleSuggestionClick']
  const next = _.pick(nextProps, paths)
  const previous = _.pick(prevProps, paths)

  const equals = _.isEqual(next, previous)
  return equals
}

export const InlineResponse = React.memo(
  InlineModal,
  inlineConatinerEquals
)

export const PopUpModal = ({
  show,
  onClose,
  className,
  breakpoint,
  handleSuggestionClick,
  onSubmit,
  widgetProps
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered={true}
      fullscreen={breakpoint === 'mobile' ? true : false}
      animation={true}
      dialogClassName={cx(styles.popupModalDialog, {
        [styles.mobileDialog]: breakpoint === 'mobile'
      })}
      contentClassName={cx(styles.popupModalContent, {
        [styles.mobileContent]: breakpoint === 'mobile'
      })}
      className={cx(styles.popupModal, className)}
      aria-labelledby='example-custom-modal-styling-title'
    >
      <SessionContainer
        onSubmit={onSubmit}
        handleSuggestionClick={handleSuggestionClick}
        breakpoint={breakpoint}
        widgetProps={widgetProps}
        onClose={onClose}
      />
    </Modal>
  )
}

const popupConatinerEquals = function (prevProps, nextProps) {
  const paths = ['className', 'widgetProps', 'breakpoint', 'show', 'onChange', 'onSubmit', 'handleSuggestionClick']
  const next = _.pick(nextProps, paths)
  const previous = _.pick(prevProps, paths)

  const equals = _.isEqual(next, previous)
  return equals
}

export const PopUpResponse = React.memo(
  PopUpModal,
  popupConatinerEquals
)

const SliderModal = ({
  show,
  onClose,
  breakpoint,
  className,
  handleSuggestionClick,
  onSubmit,
  widgetProps
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      fullscreen={true}
      animation={true}
      dialogClassName={cx(styles.sliderModalDialog)}
      className={cx(styles.sliderModal)}
      aria-labelledby='example-custom-modal-styling-title'
    >
      <SessionContainer
        handleSuggestionClick={handleSuggestionClick}
        breakpoint={breakpoint}
        onSubmit={onSubmit}
        widgetProps={widgetProps}
        onClose={onClose}
      />
    </Modal>
  )
}

const sliderConatinerEquals = function (prevProps, nextProps) {
  const paths = ['className', 'widgetProps', 'breakpoint', 'show', 'onChange', 'onSubmit', 'handleSuggestionClick']
  const next = _.pick(nextProps, paths)
  const previous = _.pick(prevProps, paths)

  const equals = _.isEqual(next, previous)
  return equals
}

export const SliderResponse = React.memo(
  SliderModal,
  sliderConatinerEquals
)
